<template>
  <div class="code-dialog">
    <h2>你的提取码为</h2>
    <div v-if="dialogData.type == 'CODE2'" class="code code2">
      <p>
        <span>完美一卡通卡号:</span>{{ dialogData.code[0] }}
        <a
          v-clipboard:copy="dialogData.code[0]"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          href="javascript:void(0);"
          >复制</a
        >
      </p>
      <p>
        <span>完美一卡通密码:</span>{{ dialogData.code[1] }}
        <a
          href="javascript:void(0);"
          v-clipboard:copy="dialogData.code[1]"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</a
        >
      </p>
      <a
        target="_blank"
        href="https://pay.wanmei.com/new/dota2/index.do?inGame=0"
        class="link-to"
        >前往充值</a
      >
    </div>
    <div v-else-if="dialogData.type == 'CODE1'" class="code code1">
      <p>
        <span></span>{{ dialogData.code.join('，') }}
        <a
          href="javascript:void(0);"
          v-clipboard:copy="dialogData.code.join(',')"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</a
        >
      </p>
    </div>
    <button @click="btnCancel" class="x"></button>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
export default {
  props: {
    dialogData: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },
  computed: {
    event_flow() {
      return this.$store.state.event_flow
    },
  },
  mounted() {
    if (this.dialogData.type == 'MAP_ESSENCE') {
      setTimeout(() => {
        this.btnCancel()
      }, 1600)
    }
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),

    btnCancel() {
      //取消
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
    onCopy() {
      console.log('复制成功')
    },
    onError() {
      console.log('复制失败')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/base.scss';
.code-dialog {
  width: 606px;
  height: 419px;
  margin: 0 auto;
  padding-top: 107px;
  background-image: url('https://img.dota2.com.cn/file/75/80/758077b3b7f04eeef49aef0d8de40fc61596606320.png');
  text-align: center;
  position: relative;
  .x {
    position: absolute;
    right: 0px;
    top: 62px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url('../../assets/close.png');
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    margin-bottom: 20px;
    color: #c3f1f6;
  }
  a.link-to {
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    width: 120px;
    height: 42px;
    line-height: 42px;
    background-color: #fa9a28;
    border-radius: 6px;
    display: inline-block;
  }
  .code {
    color: #bdbdbd;
    position: absolute;
    left: 50%;
    top: 56%;
    transform: translate(-50%, -50%);
    &.code1 {
      p {
        padding-left: 0;
        text-align: center;
      }
    }
    p {
      width: 452px;
      height: 40px;
      line-height: 38px;
      text-align: left;
      padding-left: 20px;
      background-color: #1d2831;
      margin: 0 auto 20px;
      border-radius: 6px;
      a {
        color: #52c2d6;
        float: right;
        margin-right: 20px;
      }
      span {
        color: #52c2d6;
        margin-right: 20px;
      }
    }
  }
}
</style>
